<template>
    <v-row>
        <v-col cols="7" class="pb-5">
            <v-card flat>
                <v-card-text>
                    <div
                        class="d-flex align-center justify-center"
                        style="height: 180px"
                    >
                        <v-progress-linear
                            indeterminate
                            color="blew"
                            style="width: 200px !important"
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="5" class="pb-5">
            <v-card flat>
                <v-card-text>
                    <div
                        class="d-flex align-center justify-center"
                        style="height: 180px"
                    >
                        <v-progress-linear
                            indeterminate
                            color="blew"
                            style="width: 200px !important"
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "dialog-filter-activity",
    data() {
        return {
            loading: false,
        };
    },

    mounted() {},
};
</script>



// WEBPACK FOOTER //
// LoadingChart.vue?723f9bae